module.exports = __webpack_public_path__ + "img/projek-nenas.1ba8ad28.jpeg";